<script setup>
import { computed } from 'vue';
import { Select, ChipTrigger, Icon } from '@dashhudson/dashing-ui';
import { useInteractionActions } from '@/app/community/composables/useInteractionActions';
import { communityConversationUpdateEvent } from '@/app/community/utils/mixpanel-events';
import {
  COMMUNITY_INTERACTION_ACTIONS,
  COMMUNITY_INTERACTION_ACTION_BUTTON_LOCATIONS,
  COMMUNITY_INTERACTION_PLATFORM_BY_TYPE,
} from '@/app/community/constants';

const props = defineProps({
  interaction: { type: Object, default: undefined },
  location: { type: String, default: COMMUNITY_INTERACTION_ACTION_BUTTON_LOCATIONS.PANEL },
  disabled: { type: Boolean, default: false },
});

const { updateSpamStatus } = useInteractionActions();

const spamOptions = computed(() => [
  {
    label: 'Mark as Not Spam',
    value: false,
    icon: 'remove-circle',
    severity: 'danger',
    fillClass: 'dash-fill-icon-danger',
  },
]);

const currentSpamStatus = computed(() => ({
  label: 'Spam',
  value: true,
  icon: 'message-x',
  severity: 'danger',
  fillClass: 'dash-fill-icon-danger',
}));

async function handleSpamUpdated(newSpamOption) {
  const newSpamValue = newSpamOption.value;
  await updateSpamStatus(props.interaction.id, newSpamValue, props.interaction);

  const { platform, messageType } =
    COMMUNITY_INTERACTION_PLATFORM_BY_TYPE[props.interaction.type] || {};
  const action = COMMUNITY_INTERACTION_ACTIONS.MARK_AS_NOT_SPAM;

  communityConversationUpdateEvent({
    platform,
    messageType,
    action,
    location: props.location,
    originalCommunityInteraction: props.interaction,
    updatedCommunityInteraction: { ...props.interaction, isSpam: newSpamValue },
  });
}
</script>

<template>
  <Select
    :model-value="currentSpamStatus"
    :options="spamOptions"
    return-object
    :disabled="disabled"
    @update:model-value="handleSpamUpdated"
  >
    <template #default="{ shown, selectedOptions }">
      <ChipTrigger
        :active="shown"
        :readonly="props.disabled"
        :icon="{
          name: selectedOptions?.icon || 'message-x',
          class: selectedOptions?.fillClass || 'dash-fill-icon-subtle',
        }"
      />
    </template>
    <template #optionControl="{ option }">
      <Icon :name="option.icon" :class="option.fillClass" />
    </template>
  </Select>
</template>
